import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";

const BrandingContext = createContext(null);

const DEFAULTS = { siteName: "KMS Ticari Yönetim", logoUrl: "" };

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(DEFAULTS);

  const refreshBranding = useCallback(async () => {
    try {
      const { data } = await api.get("/settings/public");
      setBranding({ siteName: data.site_name || DEFAULTS.siteName, logoUrl: data.logo_url || "" });
    } catch (e) { /* keep defaults */ }
  }, []);

  useEffect(() => { refreshBranding(); }, [refreshBranding]);

  return (
    <BrandingContext.Provider value={{ ...branding, refreshBranding }}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => useContext(BrandingContext);
